import React, { useState, useEffect } from "react"

export default function SuggestionsViewer() {
  const [shows, setShows] = useState([])
  const [selectedShowId, setSelectedShowId] = useState(null)
  const [showData, setShowData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchShows()
  }, [])

  useEffect(() => {
    if (selectedShowId) {
      fetchSuggestions(selectedShowId)
    }
  }, [selectedShowId])

  const fetchShows = async () => {
    try {
      const response = await fetch("/api/admin/shows")
      const data = await response.json()
      setShows(data)

      // Set default to active show
      const activeShow = data.find(show => show.active)
      if (activeShow) {
        setSelectedShowId(activeShow.id)
      } else if (data.length > 0) {
        setSelectedShowId(data[0].id)
      }

      setLoading(false)
    } catch (error) {
      console.error("Error fetching shows:", error)
      setLoading(false)
    }
  }

  const fetchSuggestions = async (showId) => {
    try {
      const response = await fetch(`/api/admin/suggestions?show_id=${showId}`)
      const data = await response.json()
      setShowData(data)
    } catch (error) {
      console.error("Error fetching suggestions:", error)
    }
  }

  if (loading) {
    return <div className="text-center py-8">Loading...</div>
  }

  if (shows.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No shows yet. Create a show first!</p>
      </div>
    )
  }

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Audience Suggestions</h2>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Select Show
          </label>
          <select
            value={selectedShowId || ""}
            onChange={(e) => setSelectedShowId(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
          >
            {shows.map((show) => (
              <option key={show.id} value={show.id}>
                {show.title} {show.active ? "(Active)" : ""}
              </option>
            ))}
          </select>
        </div>
      </div>

      {showData && showData.ask_fors && showData.ask_fors.length > 0 ? (
        <div className="space-y-8">
          {showData.ask_fors.map((askFor) => (
            <div key={askFor.id} className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                {askFor.prompt || "Untitled Ask For"}
              </h3>

              {askFor.suggestions && askFor.suggestions.length > 0 ? (
                <ul className="list-disc list-inside space-y-2">
                  {askFor.suggestions.map((suggestion) => (
                    <li key={suggestion.id} className="text-gray-700">
                      {suggestion.content}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-500 italic">No suggestions yet for this ask for.</p>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <p className="text-gray-500">
            {showData ? "This show has no ask fors yet." : "Select a show to view suggestions."}
          </p>
        </div>
      )}
    </div>
  )
}
